module.exports = function (element) {
    function searchBlock(el) {
        var node = $(el);
        var search_input = node.find('.js-search-input');
        var settings_link = node.find('.js-search-settings');
        var settings_block = node.find('.js-search-settings-block');
        var filter_items_block = node.find('.js-filter-items');
        var options = {
            url: function (phrase) {
                return "/moderator/suggest/tag/";
            },

            getValue: function (element) {
                return element;
            },

            ajaxSettings: {
                dataType: "json",
                method: "GET",
                data: {
                    dataType: "json"
                }
            },

            list: {
                onChooseEvent: function () {
                    node.submit();
                },
            },

            preparePostData: function (data) {
                data.term = search_input.val();
                return data;
            },

            requestDelay: 400
        };
        search_input.easyAutocomplete(options);
        search_input.on('focus', function () {
            $(this).select();
        });

        function refresh_size() {
            search_input.css('padding-left', filter_items_block.width() + 13);
        }

        settings_link.on({
            click: function () {
                settings_block.toggle();

                gtag('event', 'search_settings', {
                    'event_category': 'search'
                });

                return false;
            }
        });

        filter_items_block.find('.js-filter-items-remove').on({
            click: function () {
                let currentLocation = String(window.location);

                $(this).parent().remove();
                refresh_size();

                window.location.href = currentLocation.replace($(this).data('url'), '');
                return false;
            }
        });

        let closeAll = function (event) {
            if (settings_block.is(":visible") && !$(event.target).closest('.js-search-settings-block').length) {
                settings_block.hide();
            }
        };
        let body = $(document.body);
        body.on('click', closeAll);

        refresh_size();
    }

    if (!element) {
        throw new Error('Element undefined');
    }

    searchBlock(element);
};